import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject, Input,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

interface VisitPlanAccountSortingDialogModel {
  sortBy: string;
  sortByType: string;
}

require('./visit-plan-account-sorting-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-account-sorting-dialog',
  templateUrl: './visit-plan-account-sorting-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanAccountSortingDialogComponent implements OnInit {

  @Output() onSortTypeChange = new EventEmitter<{sortBy: string, sortByType: string}>();

  public sortByType: string;
  public sortBy: string;

  constructor(@Inject(PANEL_DATA) public data: VisitPlanAccountSortingDialogModel) {
  }

  ngOnInit() {
    this.sortBy = this.data.sortBy;
    this.sortByType = this.data.sortByType;
  }

  onToggleSortTypeChange(sortBy: string, sortByType) {
    this.sortBy = sortBy;
    this.sortByType = sortByType;
    this.onSortTypeChange.emit({sortBy: sortBy, sortByType: sortByType});
  }

}
